export const RESTORE_ALME_WINDOW = "RESTORE_ALME_WINDOW";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-launch/src/actions/actionTypes.js